import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

interface PreloadOptions {
  priority: 'high' | 'low';
  sizes?: string;
  crossOrigin?: 'anonymous' | 'use-credentials';
}

@Injectable({ providedIn: 'root' })
export class HeroCarouselPreloadService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly preloadedImages = new Set<string>();

  preload(
    imageUrl: string,
    options: PreloadOptions = { priority: 'high' }
  ): void {
    if (
      (console.log('preloadedImages: ', this.preloadedImages),
      !isPlatformBrowser(this.platformId) ||
        this.preloadedImages.has(imageUrl))
    ) {
      return;
    }

    try {
      const link = this.createPreloadLink(imageUrl, options);
      console.log('Preloading image:', imageUrl, options);
      document.head.appendChild(link);
      this.preloadedImages.add(imageUrl);
    } catch (error) {
      console.warn('Preload failed:', imageUrl, error);
    }
  }

  preloadCritical(imageUrl: string, sizes = '100vw'): void {
    this.preload(imageUrl, { priority: 'high', sizes });
  }

  preloadSecondary(imageUrl: string): void {
    this.preload(imageUrl, { priority: 'low' });
  }

  private createPreloadLink(
    imageUrl: string,
    options: PreloadOptions
  ): HTMLLinkElement {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = imageUrl;

    if (options.sizes) link.setAttribute('imagesizes', options.sizes);
    if (options.crossOrigin) link.crossOrigin = options.crossOrigin;

    // Type-safe fetchpriority
    link.setAttribute('fetchpriority', options.priority);

    return link;
  }
}
